module.exports = __webpack_public_path__ + "img/expostyle_9302_fushia_pantone7424c.a6827e1e.jpg";